import {
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Button as MuiButton,
  Dialog as MuiDialog,
} from "@mui/material";
import { Warning as MuiWarningIcon } from "@mui/icons-material";
import { Theme } from "common";

const WarningDialog = (props) => {
  const { onClose, open, title, primaryMessage, secondaryMessage, okLabel } =
    props;

  const handleOk = () => {
    onClose(false);
  };

  return (
    <MuiDialog open={open}>
      <MuiDialogTitle id="confirmation-dialog-title">
        <MuiWarningIcon
          sx={{
            color: Theme.palette.warning.main,
            verticalAlign: "sub",
            marginRight: "8px",
          }}
          fontSize="small"
        />
        {title || ""}
      </MuiDialogTitle>
      <MuiDialogContent>
        <div>{primaryMessage || ""}</div>
        <div>{secondaryMessage || ""}</div>
      </MuiDialogContent>
      <MuiDialogActions>
        <MuiButton onClick={handleOk} color="primary">
          {okLabel ? okLabel : "OK"}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default WarningDialog;
